import React, {useContext, useEffect, useState} from 'react';
import {
    Box,
    Button,
    CircularProgress,
} from '@mui/material';
import {
    useRecordContext,
    useNotify, Show
} from 'react-admin';
import { AdminUserContext } from "../../../contexts/AdminUserContextProvider";

const overlayStyles = {
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 99999,
};

const sectionTitleStyles = {
    paddingLeft: '16px',
    fontSize: '18px',
    fontWeight: 'bold',
    marginTop: '16px',
    display: 'block'
};

const SendAction = (props) => {
    const context = useContext(AdminUserContext);
    const [processing, setProcessing] = useState(false);
    const record = useRecordContext();
    const notify = useNotify();
    const [file, setFile] = useState(null);
    const [canShow, setCanShow] = useState(false);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && typeof e.target.files[0] !== 'undefined') {
            setFile(e.target.files[0]);
        }
    };

    const handleUpload = async () => {
        if (file === null) {
            notify('Please select a file to upload', { type: 'error' });
            return;
        }

        setProcessing(true);
        await context.sendIdentityDocument(file, record.id)
            .then(response => {
                setProcessing(false);
                if (typeof response.data !== 'undefined' && response.data.success === true) {
                    notify(response.data.message, { type: 'success' });
                } else {
                    notify(response.error_message, { type: 'error' });
                }
            });
    };

    const showFileSend = () => {
        if (canShow === false) {
            setCanShow(true);
        } else {
            setCanShow(false);
        }
    }

    const getWording = () => {
        return canShow ? "Hide" : "Update document";
    }

    useEffect(() => {
        if (typeof record?.identity_s3_url === 'undefined') {
            setCanShow(true);
        } else if (typeof record?.identity_s3_url !== 'undefined') {
            setCanShow(false);
        }
    }, [record]);

    return (
        <Box>
            <Box sx={ { width: '100%', display: 'flex', marginLeft: '15px', marginTop: '15px', justifyContent: 'flex-start', paddingBottom: '20px' } } >
                <div className="input-group" style={{ marginTop: '10px', display: 'block'}}>
                    { typeof record?.identity_s3_url !== 'undefined' && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: 0, marginBottom: '20px'}}>
                            <span style={{color: "green"}}>
                                <strong>Identity document available on TIP's S3 Bucket: </strong>{ record.identity_s3_url }
                            </span>
                            <Button style={{marginTop: '20px'}} onClick={() => showFileSend()} variant="contained" color="primary">
                                { getWording() }
                            </Button>
                        </Box>
                    )}
                    {canShow && (
                        <>
                            {typeof record?.identity_s3_url !== 'undefined' && (
                                <Box sx={{marginBottom: '20px'}}>
                                    <span style={{color: 'orange'}}><strong>Note:</strong> A document has already been uploaded to TIP previously. This will overwrite the previous document URL in 2.0 (above), but will not remove it from TIP's S3 bucket.</span>
                                </Box>
                            )}
                            <input id="file" style={{position: 'relative', top: '2px', display: 'inline-block', marginRight: '20px'}} type="file" onChange={handleFileChange} />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={ handleUpload }
                            >
                                <span>Upload Identity Document</span>
                            </Button>
                        </>
                    )}
                </div>
            </Box>

            { processing &&
                <Box sx={ overlayStyles } >
                    <Box sx={ { display: 'flex', flexDirection: 'column', background: '#fff', padding: '10px', borderRadius: '25px;', alignItems: 'center' } }>
                        <span style={ { marginBottom: '15px', fontSize: '20px' } } >{ "Sending file to TIP, please wait..." }</span>
                        <CircularProgress />
                    </Box>
                </Box>
            }
        </Box>
    );
}

export const TipIdentityDocument = (props) => {

    return (
        <Show title=" " actions={false}>
            <span style={sectionTitleStyles}>{"Send Identity Document to TIP"}</span>
            <SendAction />
        </Show>
    );
}